import axios from 'axios';

const getBaseURL = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  if (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
    return 'https://repair-shop-backend.smartgonext.com';
  }
  return '';
};

const api = axios.create({
  baseURL: getBaseURL(),
});

// Add interceptor to add token to every request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add interceptor to handle errors globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // AuthContext has its own response interceptor that calls logout() cleanly.
    // We don't want to perform a hard window reload here.
    return Promise.reject(error);
  }
);

export default api;
